import * as ReactRouterProperties from 'react-router-dom';
// adds support to navigate with react-router-dom v6
export const useCompatibleNavigate = () => {
    var _a;
    const { useHistory, useNavigate } = ReactRouterProperties;
    const history = useHistory === null || useHistory === void 0 ? void 0 : useHistory();
    const navigate = useNavigate === null || useNavigate === void 0 ? void 0 : useNavigate();
    return (_a = history === null || history === void 0 ? void 0 : history.push) !== null && _a !== void 0 ? _a : navigate;
};
//# sourceMappingURL=use-compatible-navigate.js.map